import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AccessGuard } from "../core/guards/access.guard";
import { PriceComparisonComponent } from './al/price-comparison/price-comparison.component';
import { EmployeeSupportPinComponent } from "./employee-support-pin/employee-support-pin.component";
import { EventRecommendationsComponent } from "./event-recommendations/event-recommendations.component";
import { MyintigrationdetailsComponent } from "./integration/myintigrationdetails/myintigrationdetails.component";
import { Page403Component } from './page403/page403.component';
import { PlanPricingComponent } from "./plan-pricing/plan-pricing.component";
import { SitesComponent } from './sites/sites.component';
import { AdminOverviewComponent } from "./starter/admin-overview/admin-overview.component";
import { NetwokSummeryComponent } from "./starter/network-summery/network-summery.component";
import { StarterComponent } from "./starter/starter.component";
import { EditsupportticketsComponent } from "./support-tickets/editsupporttickets/editsupporttickets.component";
import { SupportTicketsComponent } from "./support-tickets/support-tickets.component";
import { AddsuppportTicketsMerchantComponent } from "./suppportticketsmerchant/addsuppportticketsmerchant/addsuppportticketsmerchant.component";
import { EditsuppportTicketsMerchantComponent } from "./suppportticketsmerchant/editsuppportticketsmerchant/editsuppportticketsmerchant.component";
import { SuppportTicketsMerchantComponent } from "./suppportticketsmerchant/suppportticketsmerchant.component";
const routes: Routes = [
  { path: "", redirectTo: "home", pathMatch: "full" },
  {
    path: "starter",
    component: StarterComponent,
  },
  {
    path: "home",
    component: StarterComponent,
  },
  {
    path: "overview",
    component: AdminOverviewComponent
  },
  {
    path: "network-summery",
    canActivate: [AccessGuard],
    data: { permissionName: "Site Network", access: 1 },
    component: NetwokSummeryComponent,
  },
  {
    path: "al/price-comparison",
    component: PriceComparisonComponent,
  },

  {
    path: "restaurant",
    loadChildren: () =>
      import("./restaurant/restaurant.module").then((m) => m.RestaurantModule),
  },
  {
    path: "menumanagement",
    loadChildren: () => import("./menu/menu.module").then((m) => m.MenuModule),
  },
  {
    path: "hardware",
    loadChildren: () =>
      import("./hardware/hardware.module").then((m) => m.HardwareModule),
  },
  {
    path: "employees",
    loadChildren: () =>
      import("./employees/employees.module").then((m) => m.EmployeesModule),
  },
  {
    // path: "integration",
    path: "integration-marketplace",
    loadChildren: () =>
      import("./integration/integration.module").then(
        (m) => m.IntegrationModule
      ),
  },
  {
    path: "my-integration", component: MyintigrationdetailsComponent
  },

  {
    path: 'guests',
    loadChildren: () => import('./guests/guests.module').then(m => m.GuestsModule)
  },
  {
    path: 'onlinestore',
    loadChildren: () => import('./onlinestore/onlinestore.module').then(m => m.OnlinestoreModule)
  },
  // { path: 'sales', loadChildren: () => import('./saletransactions/saletransactions.module').then(m => m.SaletransactionsModule) },
  {
    path: "sales",
    loadChildren: () =>
      import("../pages/sales/sales.module").then((m) => m.SalesModule),
  },
  { path: 'profile', loadChildren: () => import('./profile-settings/profile-settings.module').then(m => m.ProfileSettingsModule) },
  { path: 'business-settings', loadChildren: () => import('./business-settings/business-settings.module').then(m => m.BusinessSettingsModule) },
  { path: 'reports', loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule) },
  {
    path: "ai",
    loadChildren: () => import("./ai/ai.module").then((m) => m.AiModule),
  },
  {
    path: "sites/:id",
    component: SitesComponent,
  },
  {
    path: "403",
    component: Page403Component,
  },
  {
    path: "master",
    loadChildren: () =>
      import("./master/master.module").then((m) => m.MasterModule),
  },
  {
    path: "merchants",
    loadChildren: () =>
      import("./merchants/merchants.module").then((m) => m.MerchantsModule),
  },
  {
    path: "licenses",
    loadChildren: () =>
      import("./licenses/licenses.module").then((m) => m.LicensesModule),
  },
  {
    path: "olo",
    loadChildren: () =>
      import("./olo-statistic/olo-statistic.module").then((m) => m.OloStatisticModule),
  },
  { path: 'loyalty', loadChildren: () => import('./loyalty/loyalty.module').then(m => m.LoyaltyModule) },
  { path: 'generativeai', loadChildren: () => import('./generativeai/generativeai.module').then(m => m.GenerativeaiModule) },
  { path: 'productmanagment', loadChildren: () => import('./productmanagment/productmanagment.module').then(m => m.ProductmanagmentModule) },
  { path: 'marketing', loadChildren: () => import('./marketing/marketing.module').then(m => m.MarketingModule) },
  { path: 'marketing-recommendation', loadChildren: () => import('./marketing-recommendation/marketing-recommendation.module').then(m => m.MarketingRecommendationModule) },
  {
    path: "employee-support-pin",
    component: EmployeeSupportPinComponent,
    canActivate: [AccessGuard],
    data: { permissionName: 'Users', access:1 },
  },
  {
    path: "event-recommendations",
    component: EventRecommendationsComponent,
    // canActivate: [AccessGuard],
    // data: { permissionName: 'Users', access:1 },
  },
  {
    path: "support-tickets",
    canActivate: [AccessGuard],
    data: { permissionName: "Support Tickets", access: 1 },
    component: SupportTicketsComponent,
  },
  {
    path: "support-tickets/update/:id",
    component: EditsupportticketsComponent,
  },
  {
    path: "support-tickets-merchant",
    component: SuppportTicketsMerchantComponent,
  },
  {
    path: "support-tickets-merchant/add",
    component: AddsuppportTicketsMerchantComponent,
  },
  {
    path: "support-tickets-merchant/update/:id",
    component: EditsuppportTicketsMerchantComponent,
  },
  {
    path: "plan-price",
    component: PlanPricingComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule { }
